import { AmendmentIcon } from "@logora/parliament.icons.regular_icons";
import { MemberBox } from "@logora/parliament.parliament_member.member_box";
import { Box as UiBox } from "@logora/parliament.ui.box";
import { Label } from "@logora/parliament.ui.label";
import { Box } from "@mui/material";
import React from "react";
import { Button, useRedirect } from "react-admin";
import { AlertButton } from "../alerts";
import { formatLabel } from "../formatters";
import styles from "./AmendementShow.module.scss";

export const AmendementShow = ({ resource }) => {
	const redirectTo = useRedirect();

	if (!resource) {
		return;
	}

	return (
		<Box
			display="flex"
			flexDirection="column"
			padding={"2em"}
			gap="1em"
			width={"800px"}
		>
			<Box
				display="flex"
				alignItems="center"
				justifyContent={"left"}
				gap={"1em"}
			>
				<Label
					text="Amendement"
					leftIcon={<AmendmentIcon width={18} height={18} />}
				/>
				<Box marginLeft="auto">
					<AlertButton targetClass={"Amendement"} targetId={resource.uid} />
				</Box>
			</Box>
			<div className={styles.titre}>
				{`Amendement n°${resource.numeroOrdreDepot}${
					resource.documentRef?.dossierRef
						? ` — ${resource.documentRef?.dossierRef?.titre}`
						: ""
				}`}
			</div>
			{resource.documentRef?.dossierRefUid && (
				<Box display="flex">
					<Button
						className={styles.mainButton}
						label="Voir le dossier"
						onClick={() =>
							redirectTo(
								`/parliament/dossiers/${resource.documentRef?.dossierRefUid}`,
							)
						}
					/>
				</Box>
			)}
			<Box
				display="flex"
				flexDirection="row"
				justifyContent="flex-start"
				gap="1em"
			>
				<UiBox title="Auteur">
					<MemberBox
						firstName={
							resource.acteurRef?.prenom || resource.gouvernementOrganeRef?.type
						}
						lastName={
							resource.acteurRef?.nom ||
							resource.gouvernementOrganeRef?.libelleAbrege
						}
						imageUrl={
							resource.acteurRef?.urlImage ||
							resource.gouvernementOrganeRef?.urlImage
						}
						parliamentGroup={{
							groupName: resource.acteurRef?.groupeParlementaire?.libelleAbrege,
							color: resource.acteurRef?.groupeParlementaire?.couleurAssociee,
						}}
						chamber={resource.acteurRef?.chambre}
						onClick={() =>
							resource.acteurRef
								? redirectTo(`/parliament/acteurs/${resource.acteurRefUid}`)
								: redirectTo(
										`/parliament/organes/${resource.gouvernementOrganeRef.uid}`,
									)
						}
					/>
				</UiBox>
				<UiBox title="Date de dépôt">
					<div>{new Date(resource.dateDepot).toLocaleDateString()}</div>
				</UiBox>
			</Box>
			<Box
				display="flex"
				flexDirection="row"
				justifyContent="flex-start"
				gap="1em"
			>
				<UiBox title="Étape du texte">
					<div>{resource.documentRef?.dossierRef?.statut}</div>
				</UiBox>
				<UiBox title="Statut">
					<div>{formatLabel(resource.sortAmendement)}</div>
				</UiBox>
			</Box>
			{resource.dispositif && (
				<UiBox
					title={`${resource.divisionArticleDesignation} · ${
						resource.alineaDesignation || ""
					}`}
				>
					{resource.dispositif}
				</UiBox>
			)}
			{resource.exposeSommaire && (
				<UiBox title={"Exposé des motifs"}>{resource.exposeSommaire}</UiBox>
			)}
		</Box>
	);
};
